export { default as Speech3D } from "./Speech3D.svg";
